import { render, staticRenderFns } from "./DashboardCitesTable.vue?vue&type=template&id=4f9c70f3&scoped=true"
import script from "./DashboardCitesTable.vue?vue&type=script&lang=js"
export * from "./DashboardCitesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c70f3",
  null
  
)

export default component.exports